<p-menubar [dt]="menubarHeaderDesignToken" [model]="items">
	<ng-template #start>
		<a routerLink="/">
			<div class="title desktop-only">{{ title + (fullEnvironmentString$ | async) }}</div>
			<i class="pi pi-home mobile-only title-icon"></i>
		</a>
	</ng-template>
	<ng-template #item let-item>
		@if (item.route) {
			<a [routerLink]="item.route" class="p-menubar-item-link">
				<span [class]="item.icon"></span>
				<span class="ml-2">{{ item.label }}</span>
			</a>
		} @else if (item.url) {
			<a [href]="item.url" class="p-menubar-item-link">
				<span [class]="item.icon"></span>
				<span class="ml-2">{{ item.label }}</span>
			</a>
		} @else {
			<div class="p-menubar-item-link">
				<span [class]="item.icon"></span>
				<span class="ml-2">{{ item.label }}</span>
				<span class="pi pi-fw pi-angle-down ml-2"></span>
			</div>
		}
	</ng-template>
	<ng-template #end>
		<div class="end-items">
			@if (authService.isLoggedIn$ | async) {
				<div class="release-notes-menu">
					<a routerLink="/blogs-news">
						<i class="pi pi-rss mr-2"></i>
						Blogs & News
					</a>
				</div>
				@if (isStaging$ | async) {
					<div style="cursor: pointer" class="release-notes-menu" (click)="unreleasedCommits.toggle($event)" (keydown)="unreleasedCommits.toggle($event)" tabindex="0">
						@if (unreleasedCommitsCount$ | async; as releaseNoteCount) {
							@if (releaseNoteCount > 0) {
								<div class="release-note-badge">
									<p-badge [value]="(releaseNoteCountLimit === 0 || releaseNoteCount < releaseNoteCountLimit ? releaseNoteCount : releaseNoteCountLimit + '+').toString()"></p-badge>
								</div>
							}
						}
						Unreleased commits
					</div>
				}
				@if (!(isStaging$ | async) || (isAdmin$ | async)) {
					<div style="cursor: pointer" class="release-notes-menu" (click)="productionReleaseNotes.toggle($event)" (keydown)="productionReleaseNotes.toggle($event)" tabindex="0">
						Release notes
					</div>
				}
			}

			<img class="traton-logo" alt="Traton logo" src="assets/TRATON_Logo_RGB_white.svg" />
			<div class="user-icon-container" style="cursor: pointer" (click)="menu.toggle($event)" (keydown)="menu.toggle($event)" tabindex="0">
				<p-avatar icon="pi pi-user" size="normal" shape="circle" />
			</div>
		</div>
	</ng-template>
</p-menubar>

<p-overlayPanel #unreleasedCommits>
	<div class="release-notes-list">
		<app-release-notes [releaseNotes$]="unreleasedCommits$" [notesLimit]="releaseNoteCountLimit"></app-release-notes>
	</div>
</p-overlayPanel>

<p-overlayPanel #productionReleaseNotes>
	<div class="release-notes-list">
		<app-grouped-release-notes [releaseNotes$]="releaseNotesRelease$" [editable]="true"></app-grouped-release-notes>
	</div>
</p-overlayPanel>

<p-overlayPanel #menu>
	@if (authService.userData$ | async; as userData) {
		<div class="session-content">
			@if (!!userData.sessionId) {
				<div>
					<b>{{ userData.userName }}</b>
				</div>
				<div>{{ userData.company }}</div>
			} @else {
				<a style="cursor: pointer" href="login">Login</a>
			}
		</div>
	}
</p-overlayPanel>
